import {dataTestId} from '@hconnect/uikit'
import {TextField} from '@mui/material'
import {Control, Controller, FieldValues, Path} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

interface ConfigTextFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  testId?: string
  upmId?: string
  disabled?: boolean
  isOptional?: boolean
  maxLength?: number
}

export const ConfigTextField = <T extends FieldValues>({
  control,
  name,
  label,
  testId,
  upmId,
  disabled,
  isOptional,
  maxLength
}: ConfigTextFieldProps<T>): JSX.Element => {
  const {t} = useTranslation()

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: !isOptional && t('error.required'),
        maxLength: maxLength
          ? {value: maxLength, message: t('error.maxCharactersExceeded')}
          : undefined
      }}
      render={({field: {ref, value, onChange}, fieldState: {error}}) => {
        const helperText = (error && error.message) || ''

        return (
          <TextField
            {...dataTestId(`${testId}-${upmId}`)}
            fullWidth
            disabled={disabled}
            onChange={onChange}
            value={value}
            label={t(`plantSetup.${label}`)}
            inputRef={ref}
            variant="outlined"
            error={!!error}
            helperText={helperText}
          />
        )
      }}
    />
  )
}
